import { createAction } from '@'
import FetchMappingCoverage, { notifyWrite } from './FetchMappingCoverage'
import GetHotelCoverage from './GetHotelCoverage'
import { $hotelCoverageQuery } from '../stores'

export default createAction('DeleteHotel', async hotelId => {
    const data = await FetchMappingCoverage({ method: 'DELETE', path: `/hotel/${encodeURIComponent(hotelId)}` })
    const { provider_rows: providerRows = 0, region_rows: regionRows = 0 } = data.deleted || {}
    notifyWrite(`Hotel ${hotelId} deleted (${providerRows} provider rows, ${regionRows} region links)`, data)
    const query = $hotelCoverageQuery.getState()
    if (query) {
        await GetHotelCoverage(query)
    }
    return data
})
